import Vue from 'vue';
import store from 'jystore/store';
import App from './admin.vue';

import '@/plugins/element.js';
import Print from 'vue-print-nb'
import { Sticky } from 'vant';

Vue.use(Print);
Vue.use(Sticky);
import 'vant/lib/sticky/style';

// pagebody
import JyPagebody from 'jycomponents/page/body';
Vue.component(JyPagebody.name, JyPagebody);
// badge
import JyBadge from 'jycomponents/badge/main';
Vue.component(JyBadge.name, JyBadge);
// dialog
import JyDialog from 'jycomponents/dialog/main';
Vue.component(JyDialog.name, JyDialog);
// editor
import JyEditor from 'jycomponents/editor/main';
Vue.component(JyEditor.name, JyEditor);
// button
import JyButton from 'jycomponents/button/button';
Vue.component(JyButton.name, JyButton);
// formitem
import FormItem from 'jycomponents/form/form-item';
Vue.component(FormItem.name, FormItem);
// jyoption
import JyOption from 'jycomponents/option/option';
Vue.component(JyOption.name, JyOption);
// talbe-column
import JyTableColumn from 'jycomponents/table/jy-table-column';
Vue.component(JyTableColumn.name, JyTableColumn);

// 路由表
import router from 'jyrouter/router-admin';

// console.log(router)
// vue相关配置
import '../config';
import { urlConfig } from '../config';

// 4. 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能
let _vue = new Vue({
  /*el: '#app',*/
  store: store,
  render: h => h(App),
  router
});
urlConfig(() => {
  _vue.$mount('#app');
});

// 现在，应用已经启动了！
window.BAIDU_MAP_AK = 'bkYnSHNsPvUDz0LLaKwIcvbrLk9Qp944';